import { render, staticRenderFns } from "./ShopSidebarOne.vue?vue&type=template&id=4bd737f3&scoped=true&"
import script from "./ShopSidebarOne.vue?vue&type=script&lang=js&"
export * from "./ShopSidebarOne.vue?vue&type=script&lang=js&"
import style0 from "./ShopSidebarOne.vue?vue&type=style&index=0&id=4bd737f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd737f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd737f3')) {
      api.createRecord('4bd737f3', component.options)
    } else {
      api.reload('4bd737f3', component.options)
    }
    module.hot.accept("./ShopSidebarOne.vue?vue&type=template&id=4bd737f3&scoped=true&", function () {
      api.rerender('4bd737f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/shop/sidebar/ShopSidebarOne.vue"
export default component.exports